import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Layout, { PageHero } from "@/components/Layout";
import { COMPANY } from "@/content";
import api from "@/lib/api";

const fade = { initial: { opacity: 0, y: 18 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true }, transition: { duration: 0.45 } };

export default function InvestorRelations() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/investor").then((r) => setData(r.data)).catch(() => setData({})); }, []);
  const d = data || {};

  return (
    <Layout>
      <PageHero crumb={<><Link to="/">Home</Link> / Investor Relations</>} title="Investor Relations" subtitle="Partner with us to bring objective, affordable brain diagnostics to the world." />
      <section className="section">
        <div className="wrap split">
          <motion.div className="prose" {...fade}>
            <span className="eyebrow">The opportunity</span>
            <h2 style={{ marginTop: 14, color: "#fff" }}>Seeking strategic investment</h2>
            <p style={{ color: "#fff" }}>{d.seeking}</p>
            <p style={{ color: "#fff" }}>
              For details, contact Dr. Mark Doidge at{" "}
              <a href={`mailto:${COMPANY.email}`} style={{ color: "#fff", textDecoration: "underline" }} data-testid="investor-contact-email">{COMPANY.email}</a>{" "}
              or <a href={`tel:${COMPANY.phone.replace(/[^\d+]/g, "")}`} style={{ color: "#fff", textDecoration: "underline" }} data-testid="investor-contact-phone">{COMPANY.phone}</a>.
            </p>
            <Link to="/contact" className="btn btn-primary" style={{ marginTop: 8 }}>Contact us</Link>
          </motion.div>
          <motion.div className="split-media" {...fade} transition={{ duration: 0.5, delay: 0.1 }}>
            <div className="card-panel">
              <span className="eyebrow">Investor package</span>
              <div className="doc-list" style={{ marginTop: 18 }}>
                {(d.documents || []).map((doc, i) => (
                  doc.url ? (
                    <a className="doc-item" href={doc.url} target="_blank" rel="noreferrer" key={i} data-testid={`investor-doc-${i}`}>
                      <div><b>{doc.label}</b><br /><span>{doc.note}</span></div>
                    </a>
                  ) : (
                    <div className="doc-item" key={i} data-testid={`investor-doc-${i}`}>
                      <div><b>{doc.label}</b><br /><span>{doc.note}</span></div>
                    </div>
                  )
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {d.recruiting && (
        <section className="section soft">
          <div className="wrap">
            <span className="eyebrow">Collaboration</span>
            <h2 className="h-sec">We are recruiting an academic collaborator</h2>
            <div className="card-panel prose" style={{ marginTop: 28 }}>
              <p style={{ margin: 0 }}>{d.recruiting}</p>
            </div>
          </div>
        </section>
      )}
    </Layout>
  );
}
